<p style="text-align: justify;">
  {{ 'dialog.upload.acdchemsketch' | translate }}
</p>

<app-generic-upload
  [inputId]="'chemsketch-upload-file'"
  [uploadUrl]="uploadUrl"
  [restrictions]="{ allowedExtensions: ['.zip'], maxFileSize: 4194304 }"
  [(files)]="files"
  [showRetryButton]="false"
  [showRemoveButton]="false"
  (uploadSuccess)="onSuccess($event)"
  (uploadError)="onError($event)">
</app-generic-upload>

<div class="uba-button-group">
  <button type="button" class="btn btn-default" (click)="cancel()">
    {{ 'action.cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="!canSubmit()">
    <i class="fas fa-upload" aria-hidden="true"></i>
    {{ 'action.import' | translate }}
  </button>
</div>